import { app, pages } from '@vue3/configs'
import { userCheck } from '@vue3/utils/auth'

const routes = [
  {
    path: pages.registration,
    name: app.routerName.registration,
    redirect: '/registration/dealer-type',
    meta: {
      auth: true,
      notAllowedAfterRegistration: true
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    },
    children: [
      {
        path: pages.dealerType,
        name: app.routerName.dealerType,
        component: () => import('@vue3/pages/Registration/DealerType/index.vue'),
        meta: {
          auth: true,
          notAllowedAfterRegistration: true
        },
        beforeEnter: (to, from, next) => {
          userCheck(next, to.name, from.name, to.meta)
        }
      },
      {
        path: pages.dealerInfo,
        name: app.routerName.dealerInfo,
        component: () => import('@vue3/pages/Registration/DealerInfo/index.vue'),
        meta: {
          auth: true,
          notAllowedAfterRegistration: true
        },
        beforeEnter: (to, from, next) => {
          userCheck(next, to.name, from.name, to.meta)
        }
      },
      {
        path: pages.picInfo,
        name: app.routerName.picInfo,
        component: () => import('@vue3/pages/Registration/PicInfo/index.vue'),
        meta: {
          auth: true,
          notAllowedAfterRegistration: true
        },
        beforeEnter: (to, from, next) => {
          userCheck(next, to.name, from.name, to.meta)
        }
      },
      {
        path: pages.supportDocs,
        name: app.routerName.supportDocs,
        component: () => import('@vue3/pages/Registration/SupportDocument/index.vue'),
        meta: {
          auth: true,
          notAllowedAfterRegistration: true
        },
        beforeEnter: (to, from, next) => {
          userCheck(next, to.name, from.name, to.meta)
        }
      },
      {
        path: pages.termsOfPayment,
        name: app.routerName.termsOfPayment,
        component: () => import('@vue3/pages/Registration/TermsOfPayment/index.vue'),
        meta: {
          auth: true,
          notAllowedAfterRegistration: true
        },
        beforeEnter: (to, from, next) => {
          userCheck(next, to.name, from.name, to.meta)
        }
      }
    ]
  },
  {
    path: pages.termsAndCondition,
    name: app.routerName.termsAndCondition,
    component: () => import('@vue3/pages/Registration/TermsAndCondition/index.vue'),
    meta: {
      auth: false,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.login,
    name: app.routerName.login,
    component: () => import('@vue3/pages/Login/index.vue'),
    meta: {
      auth: false,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.landingPage,
    name: app.routerName.landingPage,
    component: () => import('@vue3/pages/LandingPage/index.vue'),
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.signup,
    name: app.routerName.signup,
    component: () => import('@vue3/pages/Signup/index.vue'),
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.resetPassword,
    name: app.routerName.resetPassword,
    component: () => import('@vue3/pages/ForgotPassword/index.vue'),
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    },
    children: [
      {
        path: ':id',
        name: `${pages.resetPassword}-id`,
        component: () => import('@vue3/pages/ForgotPassword/index.vue'),
        beforeEnter: (to, from, next) => {
          userCheck(next, to.name, from.name, to.meta)
        }
      }
    ]
  },
  {
    path: pages.verifyEmail,
    name: app.routerName.verifyEmail,
    component: () => import('@vue3/pages/VerifyEmail/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: true
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.verifyEmailWithId,
    name: app.routerName.verifyEmailWithId,
    component: () => import('@vue3/pages/EmailVerificationStatus/index.vue'),
    meta: {
      auth: false,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.homePage,
    name: app.routerName.homePage,
    component: () => import('@vue3/pages/Home/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.orderList,
    name: app.routerName.orderList,
    component: () => import('@vue3/pages/OrderList/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.catalog,
    name: app.routerName.catalog,
    component: () => import('@vue3/pages/Catalog/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.rewards,
    name: app.routerName.rewards,
    component: () => import('@vue3/pages/ScanImei/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.rewardsDetail,
    name: app.routerName.rewardsDetail,
    component: () => import('@vue3/pages/RewardsDetail/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.orderDetail,
    name: app.routerName.orderDetail,
    component: () => import('@vue3/pages/OrderDetail/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      headerTabGroup: app.routerName.orderList
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.notification,
    name: app.routerName.notification,
    component: () => import('@vue3/pages/Notification/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      headerTabGroup: app.routerName.notification
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.checkout,
    name: app.routerName.checkout,
    component: () => import('@vue3/pages/Checkout/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      headerTabGroup: app.routerName.catalog
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.thankyouPage,
    name: app.routerName.thankyouPage,
    component: () => import('@vue3/pages/ThankyouPage/index.vue'),
    meta: {
      auth: true,
      notAllowedAfterRegistration: false
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.profile,
    name: app.routerName.profile,
    component: () => import('@vue3/pages/Profile/index.vue'),
    meta: {
      auth: true,
      headerTabGroup: app.routerName.homePage
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.mission,
    name: app.routerName.mission,
    component: () => import('@vue3/pages/MissionList/index.vue'),
    meta: {
      auth: true,
      headerTabGroup: app.routerName.homePage
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.missionDetail,
    name: app.routerName.missionDetail,
    component: () => import('@vue3/pages/MissionDetail/index.vue'),
    meta: {
      auth: true,
      headerTabGroup: app.routerName.homePage
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  },
  {
    path: pages.creditNote,
    name: app.routerName.creditNote,
    component: () => import('@vue3/pages/CreditNote/index.vue'),
    meta: {
      auth: true,
      headerTabGroup: app.routerName.homePage
    },
    beforeEnter: (to, from, next) => {
      userCheck(next, to.name, from.name, to.meta)
    }
  }
]


export default routes
